const Header = ({ children }) => {
    return (
        <div className="voxycure-editor__header" >
            {children}
        </div>
    );
};

export default Header;
